import React from 'react';
import Services1Header from '../components/ServicesComponents/Services1Header';
import CallToAction from '../components/Misc/CallToAction';
import ServicesSection from '../components/ServicesComponents/ServicesSection';
import Heading from '../components/Headers/Heading';

import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function ServiceStyle2() {
    return (
        <>
            <Services1Header />
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <h2 className="heading heading-very-large light-1 mb-4">Rehabilitation Programs</h2>
                                <div className="paragraph light-1">
                                    <p>Our programs are structured to address both substance use and the underlying behavioral, psychological, and social factors contributing to dependency.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="paragraph light-1">
                                    <p>We combine evidence-informed clinical care with compassionate support, providing detoxification, therapy, residential rehabilitation, and aftercare continuity.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <ServicesSection hideButton={true} />

            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Ready to start? 
                        <br />
                        Contact us today
                    </>
                }
                buttonText="Get Help Now"
                buttonLink="/contact"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need confidential advice?</>
                }
                buttonText="Contact Us"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default ServiceStyle2;
